import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "../firebase/firebase";

function LogoutScreen() {
  const navigate = useNavigate();

  useEffect(() => {
    let mounted = true;

    const doLogout = async () => {
      try {
        // Small delay so UI paints first
        await new Promise((res) => setTimeout(res, 1000));

        await signOut(auth);

        // Smooth exit delay
        await new Promise((res) => setTimeout(res, 1400));

        if (mounted) {
          navigate("/", { replace: true });
        }
      } catch (err) {
        // Fallback – never trap user here
        navigate("/", { replace: true });
      }
    };

    doLogout();

    return () => {
      mounted = false;
    };
  }, [navigate]);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background:
          "linear-gradient(135deg, #020617 0%, #0f172a 50%, #020617 100%)",
        color: "#e5e7eb",
        padding: 24,
      }}
    >
      <div
        style={{
          textAlign: "center",
          maxWidth: 420,
        }}
      >
        <div
          style={{
            fontSize: 28,
            fontWeight: 700,
            marginBottom: 12,
          }}
        >
          Wrapping things up…
        </div>

        <p
          style={{
            fontSize: 15,
            lineHeight: 1.6,
            color: "#cbd5f5",
            marginBottom: 28,
          }}
        >
          Closing claims, archiving evidence, and securing your workspace.
        </p>

        {/* Loader */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: 8,
          }}
        >
          {[0, 1, 2].map((i) => (
            <span
              key={i}
              style={{
                width: 10,
                height: 10,
                borderRadius: "50%",
                background: "#6366f1",
                animation: "pulse 1.4s infinite",
                animationDelay: `${i * 0.2}s`,
              }}
            />
          ))}
        </div>

        {/* Inline animation */}
        <style>{`
          @keyframes pulse {
            0% { opacity: 0.3; transform: scale(1); }
            50% { opacity: 1; transform: scale(1.25); }
            100% { opacity: 0.3; transform: scale(1); }
          }
        `}</style>
      </div>
    </div>
  );
}

export default LogoutScreen;
